export const init = () => {

  // TRACKER 'PRODUCT-CONVERSION'
  const tracker = new AnalyticsTracker(AnalyticsConstants.trackers.product.review);

  const productNature = '%PRODUCT_NATURE%'; // tc_vars.product_nature;
  const productName = tc_vars.product_label_displayed;
  const productId = tc_vars.product_id_model;
  const productPrice = tc_vars.product_currentprice_ati;

  const returnLabel = productName + AnalyticsConstants.concatenator + productId;

  // reviewAnchor
  const reviewAnchor = new AnalyticsClickEvent('reviewAnchor', tracker.defaultEvent());
  reviewAnchor.domElement = '.link-review.goTo';
  reviewAnchor.options.action = 'Product_Click-Review-Anchor';
  reviewAnchor.options.label = returnLabel;
  tracker.addEvent(reviewAnchor);

  // reviewTab
  const reviewTab = new AnalyticsClickEvent('reviewTab', tracker.defaultEvent());
  reviewTab.domElement = 'a[href^="#floor_user_reviews"]';
  reviewTab.options.action = 'Product_Click-Review-Tab';
  reviewTab.options.label = returnLabel;
  tracker.addEvent(reviewTab);

  // menuWriteReview
  const menuWriteReview = new AnalyticsClickEvent('menuWriteReview', tracker.defaultEvent());
  menuWriteReview.domElement = '[data-tracking="btn-write-review"]';
  menuWriteReview.options.action = 'Product_WriteMenu';
  menuWriteReview.options.label = returnLabel;
  tracker.addEvent(menuWriteReview);

  // menuSeeReviews
  const menuSeeReviews = new AnalyticsClickEvent('menuSeeReviews', tracker.defaultEvent());
  menuSeeReviews.domElement = '[data-tracking="btn-see-reviews"]';
  menuSeeReviews.options.action = 'Product_Click-All-Reviews';
  menuSeeReviews.options.label = returnLabel;
  tracker.addEvent(menuSeeReviews);

  // reviewReadMore
  const reviewReadMore = new AnalyticsClickEvent('reviewReadMore', tracker.defaultEvent());
  reviewReadMore.domElement = '.view-full-review';
  reviewReadMore.getAction = $element => {
    if ($element.closest('.review-response').length) return 'Product_ReadMore_BrandResponse';
    return 'Product_ReadMore';
  };
  reviewReadMore.getLabel = () => `${productName}-${productId}`;
  reviewReadMore.stopEvent = $element => ($element.find('.ico-less').length);
 	reviewReadMore.getReviewId = $element => {
 		const data = $element.closest('.content').find('iframe').attr('src').split('/');
 		return data[(data.length-2)];
 	};
  tracker.addEvent(reviewReadMore);


  // reviewNotation
  const reviewNotation = new AnalyticsClickEvent('reviewNotation', tracker.defaultEvent());
  reviewNotation.domElement = '.notation-box .notation-filter a';
  reviewNotation.options.action = 'Product_ReadMore';
  reviewNotation.getAction = $element => {
    const note = $element.closest('.notation-filter').find('.rate-text').text();
    return `Product_Clik-${note}`;
  };
  reviewNotation.options.label = returnLabel;
  tracker.addEvent(reviewNotation);

  CUBE.Analytics.trackers.add(tracker);
  CUBE.Analytics.trackers.init(tracker.params.name);
};



// WEBPACK FOOTER //
// ./src/analytics/trackers/product/review-tracker.js